import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const getConfigsForUiConfigSuccess = createAction('getConfigsForUiConfigSuccess');
